<template>
  <div>
    <b-row>
      <b-colxx xxs="12">
        <piaf-breadcrumb :heading="$t('menu.evidence-request')"/>
        <div class="separator mb-5"></div>
      </b-colxx>
    </b-row>
    <b-row>
      <b-colxx xxs="12">
        <b-card class="mb-4">
          <search-buttons @search="onSearch" :statusUseFlag="false" :setOption="searchOptions"/>

          <template v-if="isLoad">
            <b-row>
              <b-colxx xxs="12">
                <b-table
                  head-variant="light"
                  ref="general-table"
                  class="vuetable"
                  id="table-transition-example"
                  :items="items"
                  align="center"
                  :fields="fields"
                  :per-page="perPage"
                  :current-page="currentPage"
                  primary-key="bookingId"
                  responsive
                  show-empty>


                  <template v-slot:cell(order_no)="row">
                    <router-link :to="`order-detail/${row.item.order_no}`" class="cls_click">{{row.item.order_no}}
                    </router-link>
                  </template>
                  <template v-slot:cell(price)="row">
                    {{row.item.price | currency }}
                  </template>

                  <template v-slot:cell(buttons)="row">
                    <b-button-group vertical>
                      <b-button class="mb-2" variant="primary default" @click="confirmRefund(row.item)">완료</b-button>
                      <b-button variant="warning default" @click="denyRefund(row.item)">불가</b-button>
                    </b-button-group>
                  </template>


                  <template v-slot:empty="row">
                    <h3 style="text-align: center">해당 주문 내역이 없습니다.</h3>
                  </template>

                </b-table>
                <b-pagination v-if="lastPage > 1"
                              size="sm"
                              align="center"
                              :total-rows="total"
                              :per-page="perPage"
                              v-model="currentPage"
                >
                  <template v-slot:next-text>
                    <i class="simple-icon-arrow-right"/>
                  </template>
                  <template v-slot:prev-text>
                    <i class="simple-icon-arrow-left"/>
                  </template>
                  <template v-slot:first-text>
                    <i class="simple-icon-control-start"/>
                  </template>
                  <template v-slot:last-text>
                    <i class="simple-icon-control-end"/>
                  </template>
                </b-pagination>
              </b-colxx>
            </b-row>
          </template>
          <template v-else>
            <div class="loading"></div>
          </template>

          <deny_reason ref="Modal_deny_reason" :data="selected_memo" @confirm="memoSave" title="발급불가 사유안내"/>


        </b-card>
      </b-colxx>
    </b-row>
  </div>
</template>
<script>
  import {
    mapGetters,
    mapActions,
    mapMutations
  } from "vuex";

  import api from '../../constants/api'
  import vSelect from 'vue-select'
  import 'vue-select/dist/vue-select.css'
  import SearchButtons from "./components/SearchButtons";
  import '../../assets/css/custom/common.css'
  import {alignTableCenter, currencyFilter} from "../../utils";
  import ModalMemo from "./components/ModalMemo";

  export default {
    components: {
      'v-select': vSelect,
      'search-buttons': SearchButtons,
      'deny_reason': ModalMemo,
    },
    filters: {...currencyFilter},
    data() {
      return {
        isLoad: false,
        currentPage: 1,
        lastPage: 0,
        total: 0,
        perPage: 30,
        selected_order_no: null,
        selected_memo: null,
        fields: [
          {key: 'order_no', label: '주문번호', ...alignTableCenter},
          {key: 'goods_name', label: '상품명', ...alignTableCenter},
          {key: 'price', label: '발행금액', ...alignTableCenter},
          {key: 'document_type', label: '서류종류', ...alignTableCenter},
          {key: 'requester', label: '이름(사업자명)', ...alignTableCenter},
          {key: 'email', label: '이메일주소', ...alignTableCenter},
          {key: 'request_no', label: '신청번호', ...alignTableCenter},
          {key: 'purpose', label: '서류용도', ...alignTableCenter},
          {key: 'buttons', label: '처리상태', ...alignTableCenter},
          {key: 'file', label: '첨부파일', ...alignTableCenter},
        ],
        searchOptions: [
          {label: '주문번호', value: 'order_no'},
          {label: '상품명', value: 'goods_name'},
          {label: '구매자', value: 'buyer'},
          {label: '수신자', value: 'b2b_order_no'},
          {label: '상품명', value: 'order_path'},
        ],
        items: [],
      }
    },
    computed: {
      ...mapGetters(['currentUser', 'siteName'])
    },
    mounted() {
      this.searchData()
    },
    methods: {
      searchData() {
        this.isLoad = false
        const reqURL = api.changeAPI(this.siteName, api.basicURL + api.order)
        const params = {}

        this.$http.get(reqURL, {
          params: params,
          headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
        }).then(res => {
          if (res.data.code === "OK") {

          } else {
            throw 400
          }
        }).catch(err => {

        })

        this.items = [
          {
            order_no: '20200105195907',
            goods_name: '롯데호텔 서울 라세느 뷔페',
            price: '100000',
            document_type: '현금영수증',
            requester: '김희권',
            email: 'andy@tablenjoy.com',
            request_no: '0101001010',
            purpose: '소득공제',
            buttons: '',
            file: ''
          }, {
            order_no: '20200105195917',
            goods_name: '롯데호텔 서울 라세느 뷔페',
            price: '100000',
            document_type: '현금영수증',
            requester: '박효은',
            email: 'danny@tablenjoy.com',
            request_no: '0101001010',
            purpose: '세금계산서',
            buttons: '',
            file: ''
          },
        ]

        this.isLoad = true
      },

      onSearch(searchObj) {
        this.searchData()
      },
      confirmRefund(item) { //환불승인
        //환불처리
        alert('환불완료 ')
        const reqURL = api.changeAPI(this.siteName, api.basicURL + api.order)
        const params = {}

        this.$http.post(reqURL, params ,{
          headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
        }).then(res => {
          if (res.data.code === "OK") {

          } else {
            throw 400
          }
        }).catch(err => {

        })
      },
      denyRefund(item) { //환불 거절
        this.$refs.Modal_deny_reason.open()
      },
      memoSave() { //거절사유저장
        alert('저~~~장~~ 문자 쑝~')
      },

    }
    , watch: {
      chkeckAll(chk) {
        this.items.forEach((v) => {
          v.selected = chk
        })
      }
    }
  }
</script>
